import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class DepartmentReferenceService extends BaseReferenceService {
  constructor() {
    super('DepartmentReference');
  }
}
